export function rotateControl(options) {
  return new L.Control.Rotate(options);
}
